module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/disabledIcon.svg?15604473471a60d8d35b81626727a1c3";